<script lang="ts" setup>
    import { reactive } from 'vue';
    import { SegmentDefinition, SegmentPreviewResult } from '@cwd/views/Segments/interfaces';
    import { previewNodeSegment } from '@journeys/utils/previewNodeSegment';
    import { useResetOnNodeOrMenuChange } from '@journeys/utils/useResetOnNodeOrMenuChange';

    const props = withDefaults(
        defineProps<{
            segmentDefinition: SegmentDefinition;
            nodeId?: number;
            btnClass?: string;
        }>(),
        {
            btnClass: '',
        }
    );

    const emit = defineEmits<{
        result: [result: SegmentPreviewResult | null];
    }>();

    let abortController: AbortController | null = null;

    const state = reactive({
        loading: false,
    });

    const abortCurrentRequest = () => {
        if (abortController) {
            abortController.abort();
            abortController = null;
            state.loading = false;
        }
    };

    useResetOnNodeOrMenuChange(props, () => {
        abortCurrentRequest();
        emit('result', null);
    });

    const handlePreviewSegment = async (): Promise<void> => {
        abortCurrentRequest();

        state.loading = true;
        abortController = new AbortController();

        try {
            const result = await previewNodeSegment(props.segmentDefinition, abortController.signal);
            emit('result', result);
        } catch (error: any) {
            if (error.name !== 'AbortError') {
                throw error;
            }
        } finally {
            if (abortController) {
                state.loading = false;
                abortController = null;
            }
        }
    };
</script>

<template>
    <button
        type="button"
        :class="'btn btn-default text-wrap ' + btnClass + (state.loading ? ' is-busy' : '')"
        :disabled="state.loading"
        @click="handlePreviewSegment">
        {{ $Resources.CalculateSegmentReachHead }}
    </button>
</template>

